import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsPtypeItem extends SettingsItemForm {

  modelName = 'ptype'

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.ptype_desc}
                name="ptype_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.ptype_desc}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsPtypeItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsPtypeItem.js